<template>
  <div class="modern-footer">
    <div class="footer-content">
      <v-container fluid>
        <v-row class="footer-row">
          <!-- Contact Section -->
          <v-col cols="12" md="3" sm="6" class="footer-col">
            <div class="footer-section">
              <div class="section-header">
                <div class="section-icon">
                  <v-icon color="white" size="24">mdi-email</v-icon>
                </div>
                <h3 class="section-title">Contact Us</h3>
              </div>
              <div class="section-content">
                <div class="contact-item">
                  <v-icon small color="#8ebf42" class="mr-2">mdi-email-outline</v-icon>
                  <a href="mailto:cltsangam@gmail.com" class="contact-link">cltsangam@gmail.com</a>
                </div>
                <div class="contact-item mt-4">
                  <v-icon small color="#8ebf42" class="mr-2">mdi-map-marker</v-icon>
                  <div class="address-text">
                    <strong>P.O.Box Address</strong><br />
                    Charlotte Tamil Sangam<br />
                    P.O BOX 78131<br />
                    Charlotte NC 28277, USA
                  </div>
                </div>
              </div>
            </div>
          </v-col>

          <!-- Information Section -->
          <v-col cols="12" md="3" sm="6" class="footer-col">
            <div class="footer-section">
              <div class="section-header">
                <div class="section-icon">
                  <v-icon color="white" size="24">mdi-information</v-icon>
                </div>
                <h3 class="section-title">Information</h3>
              </div>
              <div class="section-content">
                <div class="info-card">
                  <div class="info-card-header">
                    <v-icon small color="#8ebf42" class="mr-2">mdi-home-city</v-icon>
                    <strong>New to Charlotte?</strong>
                  </div>
                  <p class="info-text">
                    We will assist you in the process of getting settled in Charlotte.
                    Whether you are planning for a short visit or you have already done that and bit lost.
                    We are here for your friendly assistance.
                  </p>
                </div>
                <div class="info-card mt-3">
                  <div class="info-card-header">
                    <v-icon small color="#8ebf42" class="mr-2">mdi-book-education</v-icon>
                    <strong>Like to Learn Tamil?</strong>
                  </div>
                  <a
                    href="https://www.antpclt.org"
                    class="tamil-link"
                    target="_blank"
                  >
                    <v-icon small class="mr-1">mdi-open-in-new</v-icon>
                    Arasinagara Tamilpalli
                  </a>
                </div>
              </div>
            </div>
          </v-col>

          <!-- Donate & Subscribe Section -->
          <v-col cols="12" md="3" sm="6" class="footer-col">
            <div class="footer-section">
              <div class="section-header">
                <div class="section-icon">
                  <v-icon color="white" size="24">mdi-hand-heart</v-icon>
                </div>
                <h3 class="section-title">Support Us</h3>
              </div>
              <div class="section-content">
                <div class="donate-section" @click="sponsor()">
                  <v-img
                    class="donate-image"
                    :src="require(`@/assets/donate.png`)"
                    contain
                    max-height="80"
                  ></v-img>
                </div>

                <div class="subscribe-section mt-4">
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <div class="subscribe-header">
                      <v-icon small color="#8ebf42" class="mr-2">mdi-bell-ring</v-icon>
                      <strong>Subscribe</strong>
                    </div>
                    <p class="subscribe-text">
                      Enter email to receive notifications about cltts events.
                    </p>
                    <div class="subscribe-input-wrapper">
                      <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        label="E-mail"
                        required
                        hide-details
                        rounded
                        solo
                        dense
                        class="subscribe-input"
                      />
                      <v-btn
                        @click="subscribe()"
                        :disabled="!valid"
                        class="subscribe-btn"
                        fab
                        small
                        color="#8ebf42"
                      >
                        <v-icon color="white">mdi-arrow-right</v-icon>
                      </v-btn>
                    </div>
                  </v-form>
                </div>
              </div>
            </div>
          </v-col>

          <!-- Help Section -->
          <v-col cols="12" md="3" sm="6" class="footer-col">
            <div class="footer-section">
              <div class="section-header">
                <div class="section-icon">
                  <v-icon color="white" size="24">mdi-lifebuoy</v-icon>
                </div>
                <h3 class="section-title">Need Help?</h3>
              </div>
              <div class="section-content">
                <div class="help-card">
                  <div class="help-header">
                    <v-icon color="#8ebf42" class="mr-2">mdi-heart-pulse</v-icon>
                    <strong>FeTNA's HELPING HEARTS</strong>
                  </div>
                  <div class="help-content">
                    <p class="help-text-tamil">
                      உங்கள் நெருக்கடி சூழலில் உடனடி உதவிக்குப் 24x7 தொலைபேசி:
                    </p>
                    <div class="hotline-number">
                      <v-icon small color="#8ebf42" class="mr-2">mdi-phone</v-icon>
                      <a href="tel:1-866-338-6244" class="phone-link">1-866-FETNAHH (1-866-338-6244)</a>
                    </div>
                    <p class="help-text-english mt-3">
                      For instance support during your crisis situations - 24x7 Hotline:
                    </p>
                    <div class="hotline-number">
                      <v-icon small color="#8ebf42" class="mr-2">mdi-phone</v-icon>
                      <a href="tel:1-866-338-6244" class="phone-link">1-866-FETNAHH (1-866-338-6244)</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Back to Top Button -->
    <div class="back-to-top-wrapper">
      <v-btn
        class="back-to-top-btn"
        fab
        @click="$vuetify.goTo(0)"
      >
        <v-icon color="white" size="28">mdi-chevron-up</v-icon>
      </v-btn>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <p class="copyright-text">
        © {{ new Date().getFullYear() }} Charlotte Tamil Sangam. All rights reserved.
      </p>
    </div>
  </div>
</template>

<script>
import ReportServices from '@/services/ReportServices'

  export default {
    data: () => ({
	valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }),
    methods: {
      reset () {
        this.$refs.form.reset()
      },
		sponsor (){
			window.open('https://my.cltts.org/#!/Chithirai-Thiruvizha-Event-Sponsor-Donations/p/549170828/category=0')
		},
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    async subscribe () {
        if (this.$refs.form.validate) {
			await ReportServices.submitSubscription(this.email)
			setTimeout(() => {
			this.$router.push('/ThankYou')
			}, 100)
		}
    }
  }
}
</script>

<style scoped lang="scss">
* {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

/* Modern Footer */
.modern-footer {
  position: relative !important;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%) !important;
  overflow: hidden !important;
}

.modern-footer::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 4px !important;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #8ebf42 100%) !important;
  background-size: 200% 100% !important;
  animation: gradientFlow 3s ease infinite !important;
}

.footer-content {
  padding: 32px 0 24px 0 !important;
  position: relative !important;
  z-index: 1 !important;
}

.footer-row {
  margin: 0 !important;
}

.footer-col {
  padding: 8px !important;
}

/* Footer Section */
.footer-section {
  height: 100% !important;
}

.section-header {
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  margin-bottom: 16px !important;
}

.section-icon {
  width: 36px !important;
  height: 36px !important;
  border-radius: 10px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow:
    0 4px 12px rgba(102, 126, 234, 0.4),
    inset 0 1px 2px rgba(255, 255, 255, 0.2) !important;
  flex-shrink: 0 !important;
}

.section-icon .v-icon {
  font-size: 20px !important;
}

.section-title {
  font-size: 17px !important;
  font-weight: 700 !important;
  color: white !important;
  margin: 0 !important;
  letter-spacing: 0.3px !important;
}

.section-content {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 13px !important;
  line-height: 1.6 !important;
}

/* Contact Section */
.contact-item {
  display: flex !important;
  align-items: flex-start !important;
  gap: 6px !important;
  margin-bottom: 8px !important;
}

.contact-link {
  color: #8ebf42 !important;
  text-decoration: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  transition: all 0.3s ease !important;
}

.contact-link:hover {
  color: #a8d96e !important;
  text-decoration: underline !important;
}

.address-text {
  color: rgba(255, 255, 255, 0.85) !important;
  line-height: 1.5 !important;
  font-size: 12px !important;
}

/* Info Cards */
.info-card {
  padding: 12px !important;
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 10px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s ease !important;
}

.info-card:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(142, 191, 66, 0.3) !important;
  transform: translateY(-2px) !important;
}

.info-card-header {
  display: flex !important;
  align-items: center !important;
  margin-bottom: 6px !important;
  color: white !important;
  font-size: 13px !important;
}

.info-text {
  font-size: 12px !important;
  color: rgba(255, 255, 255, 0.75) !important;
  line-height: 1.5 !important;
  margin: 0 !important;
}

.tamil-link {
  display: inline-flex !important;
  align-items: center !important;
  color: #8ebf42 !important;
  text-decoration: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  transition: all 0.3s ease !important;
  margin-top: 6px !important;
}

.tamil-link:hover {
  color: #a8d96e !important;
  transform: translateX(4px) !important;
}

/* Donate Section */
.donate-section {
  padding: 12px !important;
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 10px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.donate-section:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(142, 191, 66, 0.3) !important;
  transform: translateY(-4px) !important;
  box-shadow: 0 8px 20px rgba(142, 191, 66, 0.2) !important;
}

.donate-image {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3)) !important;
}

/* Subscribe Section */
.subscribe-section {
  padding: 12px !important;
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 10px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px) !important;
}

.subscribe-header {
  display: flex !important;
  align-items: center !important;
  margin-bottom: 6px !important;
  color: white !important;
  font-size: 13px !important;
}

.subscribe-text {
  font-size: 11px !important;
  color: rgba(255, 255, 255, 0.75) !important;
  line-height: 1.4 !important;
  margin: 0 0 10px 0 !important;
}

.subscribe-input-wrapper {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
}

.subscribe-input {
  flex: 1 !important;
}

.subscribe-btn {
  background: linear-gradient(135deg, #8ebf42 0%, #7aa838 100%) !important;
  box-shadow:
    0 4px 12px rgba(142, 191, 66, 0.4),
    inset 0 1px 2px rgba(255, 255, 255, 0.2) !important;
  transition: all 0.3s ease !important;
}

.subscribe-btn:hover {
  transform: scale(1.1) !important;
  box-shadow:
    0 6px 16px rgba(142, 191, 66, 0.5),
    inset 0 1px 2px rgba(255, 255, 255, 0.2) !important;
}

/* Help Section */
.help-card {
  padding: 12px !important;
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 10px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px) !important;
}

.help-header {
  display: flex !important;
  align-items: center !important;
  margin-bottom: 10px !important;
  color: white !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}

.help-content {
  font-size: 11px !important;
}

.help-text-tamil,
.help-text-english,
.help-text-alternate {
  color: rgba(255, 255, 255, 0.75) !important;
  line-height: 1.5 !important;
  margin: 0 0 6px 0 !important;
}

.hotline-number {
  display: flex !important;
  align-items: center !important;
  padding: 6px 10px !important;
  background: rgba(142, 191, 66, 0.1) !important;
  border-radius: 6px !important;
  border-left: 3px solid #8ebf42 !important;
  margin-bottom: 6px !important;
}

.phone-link {
  color: #8ebf42 !important;
  text-decoration: none !important;
  font-weight: 700 !important;
  font-size: 12px !important;
  transition: all 0.3s ease !important;
}

.phone-link:hover {
  color: #a8d96e !important;
  text-decoration: underline !important;
}

.alternate-contact {
  padding: 8px !important;
  background: rgba(255, 255, 255, 0.03) !important;
  border-radius: 6px !important;
  margin-top: 6px !important;
}

.contact-detail {
  display: flex !important;
  align-items: center !important;
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 11px !important;
  margin-bottom: 4px !important;
}

.contact-detail:last-child {
  margin-bottom: 0 !important;
}

/* Back to Top */
.back-to-top-wrapper {
  position: absolute !important;
  bottom: 60px !important;
  right: 24px !important;
  z-index: 10 !important;
}

.back-to-top-btn {
  width: 44px !important;
  height: 44px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  box-shadow:
    0 6px 16px rgba(102, 126, 234, 0.4),
    inset 0 2px 4px rgba(255, 255, 255, 0.2) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.back-to-top-btn .v-icon {
  font-size: 24px !important;
}

.back-to-top-btn:hover {
  transform: translateY(-6px) scale(1.08) !important;
  box-shadow:
    0 10px 24px rgba(102, 126, 234, 0.5),
    inset 0 2px 4px rgba(255, 255, 255, 0.2) !important;
}

/* Footer Bottom */
.footer-bottom {
  padding: 16px 0 !important;
  background: rgba(0, 0, 0, 0.3) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
  text-align: center !important;
}

.copyright-text {
  color: rgba(255, 255, 255, 0.7) !important;
  font-size: 12px !important;
  margin: 0 !important;
  letter-spacing: 0.3px !important;
}

/* Animations */
@keyframes gradientFlow {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .footer-content {
    padding: 24px 0 20px 0 !important;
  }

  .section-title {
    font-size: 16px !important;
  }

  .back-to-top-wrapper {
    bottom: 50px !important;
    right: 16px !important;
  }
}

@media (max-width: 600px) {
  .footer-content {
    padding: 20px 0 16px 0 !important;
  }

  .footer-col {
    padding: 6px !important;
  }

  .section-header {
    margin-bottom: 12px !important;
  }

  .section-icon {
    width: 32px !important;
    height: 32px !important;
  }

  .section-icon .v-icon {
    font-size: 18px !important;
  }

  .section-title {
    font-size: 15px !important;
  }

  .section-content {
    font-size: 12px !important;
  }

  .info-card,
  .help-card,
  .subscribe-section,
  .donate-section {
    padding: 10px !important;
  }

  .back-to-top-wrapper {
    bottom: 44px !important;
    right: 12px !important;
  }

  .back-to-top-btn {
    width: 40px !important;
    height: 40px !important;
  }

  .back-to-top-btn .v-icon {
    font-size: 20px !important;
  }

  .footer-bottom {
    padding: 12px 0 !important;
  }

  .copyright-text {
    font-size: 11px !important;
  }
}
</style>
